import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FlareOutlined } from '@material-ui/icons'
import cx from 'classnames/bind';

const ReferralHeader = (props = {}) => {
  return (
    <div className="header">
      <div className="header-icon">
        <div className="icon-wrapper">
          <img
            src="https://static.cdntap.com/tapfluencer/Group.png"
            alt="VIP Logo"
            className="logo-image"
          />
        </div>
      </div>
      <h1 className="header-title">Are you part of our VIParents community?</h1>
      <p className="header-subtitle">
        Join our exclusive referral program and unlock amazing rewards. Share
        the love and earn together!
      </p>
    </div>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  actions: bindActionCreators({}, dispatch),
  dispatch
})

//map state
const mapStateToProps = (state, ownProps) => ({ rdx: state })

export default connect(mapStateToProps, mapDispatchToProps)(ReferralHeader)
